/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementDetailModel} from '../models/settlement-detail/settlement-detail.model';
import {SettlementDisplayConfigurationService} from '../services/settlement-detail-configuration/settlement-display-configuration.service';
import {Subscription} from 'rxjs';
import {SettlementDisplayComponentsTypeEnum} from '../services/settlement-detail-configuration/models/settlement-display-components-type.enum';
import {SettlementDetailComponentsModel} from '../services/settlement-detail-configuration/models/settlement-detail-components.model';
import {SettlementDetailFooterActionsEnum} from '../models/settlement-detail-footer-actions.enum';
import {SettlementCreateComponentService} from '../services/settlement-create-components/settlement-create-component.service';
import {SettlementFooterActionModel} from '../models/settlement-footer-action.model';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'app-settlement-detail',
    templateUrl: './settlement-detail.component.html',
    styleUrls: ['./settlement-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettlementDetailComponent implements OnDestroy, AfterViewInit {
    @ViewChild('headerContainer', {read: ViewContainerRef}) headerContainer: ViewContainerRef;
    @ViewChild('bodyContainer', {read: ViewContainerRef}) bodyContainer: ViewContainerRef;
    @ViewChild('footerContainer', {read: ViewContainerRef}) footerContainer: ViewContainerRef;

    @Input() detailData: SettlementDetailModel = <SettlementDetailModel>{};
    @Output() footerAction: EventEmitter<SettlementFooterActionModel> = new EventEmitter<SettlementFooterActionModel>();

    private componentsConfiguration: SettlementDetailComponentsModel[];
    private subscriptions: Subscription = new Subscription();

    constructor(private detailConfiguration: SettlementDisplayConfigurationService,
                private cdr: ChangeDetectorRef,
                private componentsService: SettlementCreateComponentService) {
    }


    ngAfterViewInit(): void {
        this.updateDisplayConfiguration();
    }

    ngOnDestroy(): void {
        this.componentsService.destroyComponents();
        this.subscriptions.unsubscribe();
    }

    private updateDisplayConfiguration(): void {
        this.componentsConfiguration = this.detailConfiguration.retrieveSettlementDisplayConfiguration(this.detailData);
        this.componentsService.updateComponents(this.createComponents, this.componentsConfiguration);
    }

    private footerClick = (action: SettlementDetailFooterActionsEnum): void => {
        this.footerAction.emit({
            type: action,
            settlementData: this.detailData
        });
    };

    private createComponents = (components: SettlementDetailComponentsModel[]): void => {
        components?.forEach((item) => {
            switch (item.type) {
                case SettlementDisplayComponentsTypeEnum.HEADER:
                    this.componentsService.mapHeaderSection(item.data, this.headerContainer);
                    break;
                case SettlementDisplayComponentsTypeEnum.INFORMATION:
                    this.componentsService.mapInformationSection(item.data, this.bodyContainer);
                    break;
                case SettlementDisplayComponentsTypeEnum.SECTION_TITLE:
                    this.componentsService.mapTitleSection(item.data, this.bodyContainer);
                    break;
                case SettlementDisplayComponentsTypeEnum.AGREEMENT:
                    this.componentsService.mapAgreementSection(item.data, this.bodyContainer);
                    break;
                case SettlementDisplayComponentsTypeEnum.FOOTER:
                    this.componentsService.mapFooterSection(item.data, this.footerContainer, this.footerClick);
                    break;
                default:
                    return;
            }
        });
    };
}
